import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, Observable } from 'rxjs';
import { TableService } from './table-service';
import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { KeyValuePair } from '@morningstar/shared/models';
import { tap, filter } from 'rxjs/operators';

export abstract class TableDialogService<T> extends TableService<T> {

  closeDialog = new Subject();
  closeDialog$ = this.closeDialog.asObservable();

  constructor(snackbar: MatSnackBar, httpClient: HttpClient, @Inject('API_BASE_URL') protected baseUrl: string) {
    super(snackbar, httpClient, baseUrl);
  }

  add<T, R = void>(datum: T, endpoint: string, params?: KeyValuePair[], closeDialog?: boolean): Observable<R> {
    return super.add<T, R>(datum, endpoint, params).pipe(
      tap(() => {
        if (closeDialog) {
          this.closeDialog.next()
        }
      })
    )
  }

  update(datum: T, endpoint: string, params?: KeyValuePair[], closeDialog?: boolean): Observable<void> {
    return super.update(datum, endpoint, params).pipe(
      tap(() => {
        if (closeDialog) {
          this.closeDialog.next()
        }
      })
    )
  }
}
